// extracted by mini-css-extract-plugin
export default {"component":"bqqnO9","headline":"cqqnO9","subtitle":"dqqnO9"};